export const LstList = [
    {
        "name": "FP SOL",
        "symbol": "fpSOL",
        "mint": "fpSoL8EJ7UA5yJxFKWk1MFiWi35w8CbH36G5B9d7DsV",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/igneous-labs/lst-offchain-metadata/master/fpSOL/fpSOL.jpg",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "GutG5bcmEZw15WmPHNVMWHU77c6t8CEinUEdPLYz3doa",
            "validatorList": "DfVmEvxkRBgFfYHgrtN9AcEv7gWXUtB1QZ6hkD3aYzsc"
        }
    },
    {
        "name": "dogwifSOL",
        "symbol": "wifSOL",
        "mint": "Fi5GayacZzUrfaCRCJtBz2vSYkGF56xjgCceZx5SbXwq",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://bpjbeqpzm6vvgd5eafntpuhxgbxdfbbd2jhvnbwp33ql7xgcbo6q.arweave.net/C9ISQflnq1MPpAFbN9D3MG4yhCPST1aGz97gv9zCC70",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "9Z8yimuc3bQCWLDyMhe6jfWqNk9EggyJZUo8TLnYsqhN",
            "validatorList": "DfCHoraRZ6XWmqiqCtqTD27GHMUh4YB1oxRJMhMHJYNx"
        }
    },
    {
        "name": "Pathfinders SOL",
        "symbol": "pathSOL",
        "mint": "pathdXw4He1Xk3eX84pDdDZnGKEme3GivBamGCVPZ5a",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/igneous-labs/lst-offchain-metadata/master/pathSOL/pathSOL.png",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "GM7TwD34n8HmDP9XcT6bD3JJuNniKJkrKQinHqmqHarz",
            "validatorList": "2WqKyuuonwMhjYpvLFZSBibBddB8DNVTij5AuWYFs4KD"
        }
    },
    {
        "name": "Jupiter Staked SOL",
        "symbol": "JupSOL",
        "mint": "jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://static.jup.ag/jupSOL/icon.png",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "8VpRhuxa7sUUepdY3kQiTmX9rS5vx4WgaXiAnXq4KCtr",
            "validatorList": "AXL4v4bbzRkqwHmLc9A1YzHQmRhmG9Q93i1e6CPG2bEK"
        }
    },
    {
        "name": "Juicing Jupiter SOL",
        "symbol": "juicingJupSOL",
        "mint": "BgYgFYq4A9a2o5S1QbWkmYVFBh7LBQL8YvugdhieFg38",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://static.jup.ag/jupSOL/icon.png",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "4mBwcXKJN2vz6MJikNTgVBSY5vYnyjZk7txd8j3K46Ei",
            "validatorList": "6j13ZPRzMcyjJqUd5fJYfqa6pqhmDfD87mDgjMGvnff2"
        }
    },
    {
        "name": "Phase Labs SOL",
        "symbol": "phaseSOL",
        "mint": "phaseZSfPxTDBpiVb96H4XFSD8xHeHxZre5HerehBJG",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/phaselabscrypto/.github/main/profile/public/phaseSOL.png",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "phasejkG1akKgqkLvfWzWY17evnH6mSWznnUspmpyeG",
            "validatorList": "phaseeExd43yGjjad2FZSigdG9UTRpMdxS4aMerx821"
        }
    },
    {
        "name": "banxSOL",
        "symbol": "banxSOL",
        "mint": "BANXyWgPpa519e2MtQF1ecRbKYKKDMXPF1dyBxUq9NQG",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/3ryTeptAwpdI57CnL1tfitjnitj2s6P_A_m2RiARE7M",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "4fdMvFuyNboQ5Kr93X16f1tFcTeEkvfNwNAeSrzY3afb",
            "validatorList": "25vgWN38FKfcbejXcNvgwKJ2YR6TBudgxmkr5NhRJKzT"
        }
    },
    {
        "name": "iceSOL",
        "symbol": "iceSOL",
        "mint": "iceSdwqztAQFuH6En49HWwMxwthKMnGzLFQcMN3Bqhj",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/vIJdshKQBC9cE8V190WgRhYqdjb8HhUJAMmP69gvAFI",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "EVXQHaLSJyUNrnBGfXUnvEi4DvVz4UJ3GnoKGVQVxrjr",
            "validatorList": "4uSMQWg19CNj4qEnTDfZpRuTKbUTeFF1KRACS7PSzRjX"
        }
    },
    {
        "name": "SolanaFM Staked SOL",
        "symbol": "fmSOL",
        "mint": "fmSoLKzBY6h9b5RQ67UVs7xE3Ym6mx2ChpPxHdoaVho",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://bafybeiefm3rrcglj2pithpllphuqataudxwepdt66jlmted3mfhybhvg34.ipfs.w3s.link/128x128.png",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "5FYTvZgc7QEGZSDmbJn5hrtjtRtyFZo5vR7gL1jJYanE",
            "validatorList": "khxkNN9Ke1evzgBM1koNGcXfDZ2xLUJorEpUQu1zsot",
            "voteAccount": "3zH61eoL7aL626arSqKEbfsx2kPb6P3WFU9ERUWciPSq"
        }
    },
    {
        "name": "BurnDAO",
        "symbol": "BurnSOL",
        "mint": "AxM7a5HNmRNHbND6h5ZMSsU8n3NLa1tskoN6m5mAgVvL",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://blue-selected-otter-455.mypinata.cloud/ipfs/QmUezUvUBny2XhzGm9BiZ7PQrbWA1R8szaTMcYMrqWXNKX",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "CAEsfzw43mvaVauCxXCSJh8DvnFsTMiTyeL1kjs6UwaT",
            "validatorList": "8QsyXperTQHzv7huu1ZB1QV9jzD7BKzNVkgsniCqzUGL",
            "voteAccount": "he1iusunGwqrNtafDtLdhsUQDFvo13z9sUa36PauBtk"
        }
    },
    {
        "name": "mallowSOL",
        "symbol": "mallowSOL",
        "mint": "MLLWWq9TLHK3oQznWqwPyqD7kH4LXTHSKXK4yLz7LjD",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/b0JcLRjgOigociJMInQzY9eVsFTwzV0OUdbpJ_LZ9xo",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "7thbAQrn9oRJsbz2CchoPSujGYpu4hCHnVrniBHupQsx",
            "validatorList": "21RD9B26CJFTBt7FYJqXWycjbrALQXLFNxnT88y5pu8H",
            "voteAccount": "he1iusunGwqrNtafDtLdhsUQDFvo13z9sUa36PauBtk"
        }
    },
    {
        "name": "Pine Staked SOL",
        "symbol": "pineSOL",
        "mint": "SnKAf8aNjeYz8pY8itYn3VxFhT6Q8WNdPwy17s9USgC",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/kDokz1I26JRz9RhP93htZRO97O6o-tuKe7YbHz2zcS4",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "AArUn1RkrCejbciMwd9t7a8TFLHaBRHBzaQXiM9B48aH",
            "validatorList": "34VvniHqR9MiudeGbwjMrsb9wbkW77TuyXwc2HLUG7Gs"
        }
    },
    {
        "name": "UwU Staked SOL",
        "symbol": "uwuSOL",
        "mint": "9zecJ6ryY3PXfW1wTd1Nz1GR9hzWhMYw62KDbvSyEJAj",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/fLPUZ2PGTDo5e8sLBHGPlq_Hwdgnmt9nY3lyfCGYGMg",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "8pyNtuJdY75y7W6vVPanTy4piEr3nZUejDCkN2nQ6csH",
            "validatorList": "4SCXfhEFbUXs5KR5HQywsRkWcoAsofhGVGex9Xk5YzJV"
        }
    },
    {
        "name": "UpRock SOL",
        "symbol": "uptSOL",
        "mint": "uPtSoL2qszk4SuPHNE2zqk1gDtqCq21ZE1yZCqvFTqq",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/uprockcom/upt-sol/main/logo.png",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "5UMja2dWNX3XhrBAvsoRteySTngfpQGHrWfHxueCs5s6",
            "validatorList": "FAr8zNTtTUCu2sSnGRp8mUTGos755bm6EYkBLwzjX9VT"
        }
    },
    {
        "name": "Flojo Staked SOL",
        "symbol": "flojoSOL",
        "mint": "43CXsrQV7WyMvBsUiiZQMNU5Sdp28Jy61YMtx4J3RT7T",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://ipfs.filebase.io/ipfs/QmZULAmgP19RSGfGiQSm5AvHusTsASp6CWhBTQTfbp9aMm",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "141oNu5DmA5nkoVACZVXMgy6KDFN1PftaTjbzzXvTXbT",
            "validatorList": "AsRuK1PdjxRKdenfvfvqyoG9TX2maJbNhQWbAMyiZC6d"
        }
    },
    {
        "name": "healthSOL",
        "symbol": "healthSOL",
        "mint": "HEALfPnLU31roNrnhB8bHWQVszMMAKro4KJRrnkQyVpZ",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/wpNG0yio0JzRcvxmN-mfUu1sfCnwF9NLo6OoZtijcpA",
        "pool": {
            "program": "SanctumSplMulti",
            "pool": "Ceuqmz4qrwjrKnpBt4Byen58mfvbAAh67vDJqnsBkoPD",
            "validatorList": "7mUknquh6kZxni9vr7cdA6NeFpcT7dimdhqYspxHQ4it"
        }
    },
    {
        "name": "Power Staked SOL",
        "symbol": "pwrSOL",
        "mint": "pWrSoLAhue6jUxUkbWgmEy5rD9VJzkFmvfTDV5KgNuu",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/vmJI1aPZNfTTIWH7ZLFxBP1VK7ptapg1hBukoDDNPME",
        "pool": {
            "program": "SanctumSpl",
            "pool": "DfiQgSvpW3Dy4gKfhtdHnWGHwFUrE8exvaxqjtMtAVxk",
            "validatorList": "9PYGjoQhY89f8t3NVtq82MN91RDvoEkkFtcQyuVAuWGL",
            "voteAccount": "LodezVTbz3v5GK6oULfWNFfcs7D4rtMZQkmRjnh65gq"
        }
    },
    {
        "name": "Superfast Staked SOL",
        "symbol": "superSOL",
        "mint": "suPer8CPwxoJPQ7zksGMwFvjBQhjAHwUMmPV4FVatBw",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://superfast.org/supersollogo.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "4dZDUL3BFJUFeqS3Y3cwkc84Rs6mgVHRYGt1LJvhooW4",
            "validatorList": "F7MiLkUWkBVee6d3Evppgcr7iNKgG94H5PMu9WCjj4mQ",
            "voteAccount": "R1vAoSPFQdCc6wsAEMtxWXjqptSeN1YUiq2Zni1of21"
        }
    },
    {
        "name": "Juicy SOL",
        "symbol": "jucySOL",
        "mint": "jucy5XJ76pHVvtPZb5TKRcGQExkwit2P5s4vY8UzmpC",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://shdw-drive.genesysgo.net/5ohvXVJ7f3HxnwYGnXKdECWC3KFcU95dHu7S7x69Y1sA/logo_rev.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "AZGSr2fUyKkPLMhAW6WUEKEsQiRMAFKf8Fjnt4MFFaGv",
            "validatorList": "GzsFwdtyhGmBEEh7hnfJi6u6rXJYMDPjL8Keo6Q2dZYK",
            "voteAccount": "juicQdAnksqZ5Yb8NQwCLjLWhykvXGktxnQCDvMe6Nx"
        }
    },
    {
        "name": "bonkSOL",
        "symbol": "bonkSOL",
        "mint": "BonK1YhkXEGLZzwtcvRTip3gAL9nCeQD7ppZBLXhtTs",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/ms-FdIyJ8TxEJOb2SAYhfyrLop7TDrCEjD-I-oIl5u4",
        "pool": {
            "program": "SanctumSpl",
            "pool": "ArAQfbzsdotoKB5jJcZa3ajQrrPcWr2YQoDAEAiFxJAC",
            "validatorList": "Ea2ATXQgQrUXGdMPXUbdNw8SmV3S6RSzsiff8AcBLP2G",
            "voteAccount": "J1to3PQfXidUUhprQWgdKkQAMWPJAEqSJ7amkBDE9qhF"
        }
    },
    {
        "name": "Drift Staked SOL",
        "symbol": "dSOL",
        "mint": "Dso1bDeDjCQxTrWHqUUi63oBvV7Mdm6WaobLbQ7gnPQ",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://drift-public.s3.eu-central-1.amazonaws.com/dSOL.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "9mhGNSPArRMHpLDMSmxAvuoizBqtBGqYdT8WGuqgxNdn",
            "validatorList": "4dRHzwW2npecE4riAKibHccnMib5jBu9RdFf8bQ2o7Mo",
            "voteAccount": "DriFTm3wM9ugxhCA1K3wVQMSdC4Dv4LNmyZMmZiuHRpp"
        }
    },
    {
        "name": "Compass SOL",
        "symbol": "compassSOL",
        "mint": "Comp4ssDzXcLeu2MnLuGNNFC4cmLPMng8qWHPvzAMU1h",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://solanacompass.com/compass.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "AwDeTcW6BovNYR34Df1TPm4bFwswa4CJY4YPye2LXtPS",
            "validatorList": "DgSrw8Kmww4wVC1KaHFrEYE3UiCupNpLde2CcUEmGYsx",
            "voteAccount": "EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72"
        }
    },
    {
        "name": "picoSOL",
        "symbol": "picoSOL",
        "mint": "picobAEvs6w7QEknPce34wAE4gknZA9v5tTonnmHYdX",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/zR2ZKXpwmG4hMpqhGXlvz-B7PMs34cXxVb2gC1DmlDo",
        "pool": {
            "program": "SanctumSpl",
            "pool": "8Dv3hNYcEWEaa4qVx9BTN1Wfvtha1z8cWDUXb7KVACVe",
            "validatorList": "46A5KjX8J6FAUTXwcE8iJkmM7igK3v8vy1MD74cZNWVE",
            "voteAccount": "3xjfK9C9YNcta8MvK1US4sQ3bc6DEjoJoR3qLExGf9xE"
        }
    },
    {
        "name": "Overclock SOL",
        "symbol": "clockSOL",
        "mint": "GRJQtWwdJmp5LLpy8JWjPgn5FnLyqSJGNhn5ZnCTFUwM",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/Overclock-Validator/assets/main/img.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "6e2LpgytfG3RqMdYuPr3dnedv6bmHQUk9hH9h2fzVk9o",
            "validatorList": "9hVn2PQWj7i3sSEzPhzgUaAAscjRJXd8v54mmR7Y3s9U",
            "voteAccount": "AS3nKBQfKs8fJ8ncyHrdvo4FDT6S8HMRhD75JjCcyr1t"
        }
    },
    {
        "name": "SolanaHub staked SOL",
        "symbol": "hubSOL",
        "mint": "HUBsveNpjo5pWqNkH57QzxjQASdTVXcSK7bVKTSZtcSX",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/RI0OfNg4Ldn5RRdOp9lE60NqUmweGtJxF5N8JjU_Y0k",
        "pool": {
            "program": "SanctumSpl",
            "pool": "ECRqn7gaNASuvTyC5xfCUjehWZCSowMXstZiM5DNweyB",
            "validatorList": "5Aueao7mrWvL4GFswwdXmFCRw1j7AjYb8aJeMFeYv6zo",
            "voteAccount": "7K8DVxtNJGnMtUY1CQJT5jcs8sFGSZTDiG7kowvFpECh"
        }
    },
    {
        "name": "Stronghold LST",
        "symbol": "strongSOL",
        "mint": "strng7mqqc1MBJJV6vMzYbEqnwVGvKKGKedeCvtktWA",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://shdw-drive.genesysgo.net/CqCTE2k6ext17JLE7EFk6pXAznS7m1rLJaN9nHxUAwpc/stronghold.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "GZDX5JYXDzCEDL3kybhjN7PSixL4ams3M2G4CvWmMmm5",
            "validatorList": "6deuDrZgAJ57e2qKV8yykidjzWxAsBfdaiakG8yjX3Tk",
            "voteAccount": "Ac1beBKixfNdrTAac7GRaTsJTxLyvgGvJjvy4qQfvyfc"
        }
    },
    {
        "name": "Lantern Staked SOL",
        "symbol": "lanternSOL",
        "mint": "LnTRntk2kTfWEY6cVB8K9649pgJbt6dJLS1Ns1GZCWg",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/juI8rxciTff6pljaDiXMEq5klSOngQol_8lvyokGGwY",
        "pool": {
            "program": "SanctumSpl",
            "pool": "LW3qEdGWdVrxNgxSXW8vZri7Jifg4HuKEQ1UABLxs3C",
            "validatorList": "GM7T5roJWhQchJErSZdPeHvkw43MkvVC6b8DK4BNuidP",
            "voteAccount": "FACqsS19VScz8oo2YhdMg35EsAy6xsCZ9Y58eJXGv8QJ"
        }
    },
    {
        "name": "Stake City SOL",
        "symbol": "stakeSOL",
        "mint": "st8QujHLPsX3d6HG9uQg9kJ91jFxUgruwsb1hyYXSNd",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/C2P2vlj4GZF1ZfAj5GV7B7cvpvdiz2tDEwh6hOfml_o",
        "pool": {
            "program": "SanctumSpl",
            "pool": "2jjK1MsLgsPgVjnp97HUJeovNj3jp4XgyQ3nuiWMwiS8",
            "validatorList": "HJTGs6mPX7nE84kU1s4c5VRwNbtUxGgUj8qTbzakSXAH",
            "voteAccount": "CiTYUYPAPHdcri5yEfsmqVcs54J6j8X1QaiFLgYqMVe"
        }
    },
    {
        "name": "Pumpkin's Staked SOL",
        "symbol": "pumpkinSOL",
        "mint": "pumpkinsEq8xENVZE6QgTS93EN4r9iKvNxNALS1ooyp",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/bartenbach/pumpkins_pool/main/assets/img/pumpkintoken.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "8WHCJsUduwDBhPL9uVADQSdWkUi2LPZNFAMyX1n2HGMD",
            "validatorList": "5wQr2KeodHLNikQgNQTeEEoFZuNgvP2oD9c4izDf2TuQ",
            "voteAccount": "DsiG71AvUHUEo9rMMHqM9NAWQ6ptguRAHyot6wGzLJjx"
        }
    },
    {
        "name": "Helius Staked SOL",
        "symbol": "hSOL",
        "mint": "he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/igneous-labs/lst-offchain-metadata/master/hSOL/hSOL.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "3wK2g8ZdzAH8FJ7PKr2RcvGh7V9VYson5hrVsJM5Lmws",
            "validatorList": "TCxWHorDSe3vWydw6MGwyexcqm3ZU9RT7VTqiCcN6y9",
            "voteAccount": "he1iusunGwqrNtafDtLdhsUQDFvo13z9sUa36PauBtk"
        }
    },
    {
        "name": "Lifinity Staked SOL",
        "symbol": "lifSOL",
        "mint": "LSoLi4A4Pk4i8DPFYcfHziRdEbH9otvSJcSrkMVq99c",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/L1EMXV4iQpoU6uUJzB3RxBkJ8Yhmsiqt5b1ju_Hz1Jg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "HSDnqBq7EnfcKpnw52DTAZrP38tf8rdWLiRhQo4qGTUa",
            "validatorList": "9JLWSXToxx1Kn28jwix3eCUc4Rvz3VN41Km3tKA4adFB",
            "voteAccount": "2ayMCC4aizr8RGg5ptXYqu8uoxW1whNek1hE1zaAd58z"
        }
    },
    {
        "name": "Cogent SOL",
        "symbol": "cgntSOL",
        "mint": "CgnTSoL3DgY9SFHxcLj6CgCgKKoTBr6tp4CPAEWy25DE",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://cogent-cogs.s3.us-west-2.amazonaws.com/cgntSOL.png",
        "pool": {
            "program": "Spl",
            "pool": "CgntPoLka5pD5fesJYhGmUCF8KU1QS1ZmZiuAuMZr2az",
            "validatorList": "CGNTvFQ5yhxp2H5RmmXJ2w3LXJ3kAHrgPMrfABBTkeTr",
            "voteAccount": "CogentC52e7kktFfWHwsqSmr8LiS1yAtfqhHcftCPcBJ"
        }
    },
    {
        "name": "Laine Stake Token",
        "symbol": "laineSOL",
        "mint": "LAinEtNLgpmCP9Rvsf5Hn8W6EhNiKLZQti1xfWMLy6X",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://vvmbtadq63n53sdsqhlzbnzhvj5tdfp7moqixyv7rgkk6frqhqqq.arweave.net/rVgZgHD2293IcoHXkLcnqnsxlf9joIviv4mUrxYwPCE",
        "pool": {
            "program": "Spl",
            "pool": "2qyEeSAWKfU18AFthrF7JA8z8ZCi1yt76Tqs917vwQTV",
            "validatorList": "sHPN95ARJpwN3Yipc22Z3m5118K3czRLBG7WmLDLsMp",
            "voteAccount": "GE6atKoWiQ2pt3zL7N13pjNHjdLVys8LinG8qeJLcAiL"
        }
    },
    {
        "name": "The Vault",
        "symbol": "vSOL",
        "mint": "vSoLxydx6akxyMD9XEcPvGYNGq6Nn66oqVb3UkGkei7",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://bafkreig55mf3lazzbgndiqyqvdmchdsykvvebww7cqlws6ywgog5xfdzta.ipfs.nftstorage.link/",
        "pool": {
            "program": "Spl",
            "pool": "Fu9BYC6tWBo1KMKaP3CFoKfRhqv9akmy3DuYwnCyWiyC",
            "validatorList": "3wsE11pAjCE3sCwokhD5kgi5cjv6hi3DGAkxXB5MMHKL"
        }
    },
    {
        "name": "BlazeStake Staked SOL",
        "symbol": "bSOL",
        "mint": "bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1/logo.png",
        "pool": {
            "program": "Spl",
            "pool": "stk9ApL5HeVAwPLr3TLhDXdZS8ptVu7zp6ov8HFDuMi",
            "validatorList": "1istpXjy8BM7Vd5vPfA485frrV7SRJhgq5vs3sskWmc"
        }
    },
    {
        "name": "daoSOL",
        "symbol": "daoSOL",
        "mint": "GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/GEJpt3Wjmr628FqXxTgxMce1pLntcPV4uFi8ksxMyPQh/logo.png",
        "pool": {
            "program": "Spl",
            "pool": "7ge2xKsZXmqPxa3YmXxXmzCp9Hc2ezrTxh6PECaxCwrL",
            "validatorList": "CKG4Jci9tGSrZtetnLXuDKV2WqaknFCUX9CY3ahfw2n6"
        }
    },
    {
        "name": "Jito Staked SOL",
        "symbol": "JitoSOL",
        "mint": "J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://storage.googleapis.com/token-metadata/JitoSOL-256.png",
        "pool": {
            "program": "Spl",
            "pool": "Jito4APyf642JPZPx3hGc6WWJ8zPKtRbRs4P815Awbb",
            "validatorList": "3R3nGZpQs2aZo5FDQvd2MUQ6R7KhAPainds6uT6uE2mn"
        }
    },
    {
        "name": "JPOOL Solana Token",
        "symbol": "JSOL",
        "mint": "7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/7Q2afV64in6N6SeZsAAB81TJzwDoD6zpqmHkzi9Dcavn/logo.svg",
        "pool": {
            "program": "Spl",
            "pool": "CtMyWsrUtAwXWiGr9WjHT5fC3p3fgV8cyGpLTo2LJzG1",
            "validatorList": "Ei2LhH2tDKPERnoNjQV5darTToZmbg45vDvftFFLNNWd"
        }
    },
    {
        "name": "Liquid Staking Token",
        "symbol": "LST",
        "mint": "LSTxxxnJzKDFSLr4dUkPcmCf5VyryEqzPLz5j4bpxFp",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://storage.googleapis.com/static-marginfi/lst.png",
        "pool": {
            "program": "Spl",
            "pool": "DqhH94PjkZsjAqEze2BEkWhFQJ6EyU6MdtMphMgnXqeK",
            "validatorList": "77Nc7i2Pe4ktkPVsk2KsZeLZRMUMKpddheBUgW727XR4"
        }
    },
    {
        "name": "Zippy Staked SOL",
        "symbol": "zippySOL",
        "mint": "Zippybh3S5xYYam2nvL6hVJKz1got6ShgV4DyD1XQYF",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://www.zippystake.org/mint.png",
        "pool": {
            "program": "Spl",
            "pool": "DxRFpqBQBC2nKcvh14gD1eizCj9Xi7ruMR3nCR3Hvw8f",
            "validatorList": "FrBwWukdviJHrJqfbxkrb1GzV9XdY5qVwXxN53cHvC8y"
        }
    },
    {
        "name": "Edgevana Staked SOL",
        "symbol": "edgeSOL",
        "mint": "edge86g9cVz87xcpKpy3J77vbp4wYd9idEV562CCntt",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://srv.edgevana.com/img/edgesol.png",
        "pool": {
            "program": "Spl",
            "pool": "edgejNWAqkePLpi5sHRxT9vHi7u3kSHP9cocABPKiWZ",
            "validatorList": "edgeUAwci9fD66ffrfxKZtznzrm79hHcpjR1BaYF8ML"
        }
    },
    {
        "name": "Enhanced Linkage SOL",
        "symbol": "elSOL",
        "mint": "ELSoL1owwMWQ9foMsutweCsMKbTPVBD9pFqxQGidTaMC",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/4q1KEew_Kqymx6rea_b-VeDX337130aPv0omKRAGPHU",
        "pool": {
            "program": "Spl",
            "pool": "So1vW4Bm6ZURzJJHZy1JpsjoVY68z4cDgF4tTLwYMa5",
            "validatorList": "6iAzfHnUkQTETATNjd8h7hHME5rERAKrRJidbAZL9vL9"
        }
    },
    {
        "name": "aeroSOL",
        "symbol": "aeroSOL",
        "mint": "aeroXvCT6tjGVNyTvZy86tFDwE4sYsKCh7FbNDcrcxF",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/phaselabscrypto/.github/main/profile/public/aeroSOL.png",
        "pool": {
            "program": "Spl",
            "pool": "aero2ePURjuEgLKTzcUmF6RypBncBGd7pMUYCoSsVJ6",
            "validatorList": "aero4efZ7zHhWpqXQj4Uqw59koxj8KXqMCPUuvmhgUQ"
        }
    },
    {
        "name": "Binance Staked SOL",
        "symbol": "BNSOL",
        "mint": "BNso1VUJnh4zcfpZa6986Ea66P6TCp59hvtNJ8b1X85",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/LepI-hea-JrbLMb4L_HpMzaq9k0aHY2-lVSGiBtwvFM?ext=png",
        "pool": {
            "program": "Spl",
            "pool": "Hr9pzexrBge3vgmBNRR8u42CNQgBXdHm4UkUN2DH4a7r",
            "validatorList": "FQxPPqmKKiRH3q2Sqb1xvdafqbbVyBPpMUnDug4AjtkX"
        }
    },
    {
        "name": "Thugbirdz Staked SOL",
        "symbol": "thugSOL",
        "mint": "ThUGsoLWtoTCfb24AmQTKDVjTTUBbNrUrozupJeyPsy",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://srnhpxb74glblifrf53e2dcgserxvjeznibzbbvkesg4wqlu7xmq.arweave.net/lFp33D_hlhWgsS92TQxGkSN6pJlqA5CGqiSNy0F0_dk",
        "pool": {
            "program": "SanctumSpl",
            "pool": "G9WdMBxWSo1X3fKxbuyGrv1nGXrVqGg5zBKAkBFkb37g",
            "validatorList": "2iqLLYWs1GXxDqwdihDGVXdx411FhzfdHtg9jNqAwogf",
            "voteAccount": "H7fXvnLCKtZqJBTipxeseabGfAZUdHJ9XuP6hCKrbvUb"
        }
    },
    {
        "name": "Wen Staked SOL",
        "symbol": "wenSOL",
        "mint": "WensoLXxZJnev2YvihHFchn1dVVFnFLYvgomXWvvwRu",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://hqwsxqydipojktnc77mn3dscmpthicc7nrvom5sgif7toqrtxm2a.arweave.net/PC0rwwND3JVNov_Y3Y5CY-Z0CF9sauZ2RkF_N0IzuzQ",
        "pool": {
            "program": "SanctumSpl",
            "pool": "CWM1VcNPd2A5WF2x2mmEUCgA1PGSKNZCGAH5GsoQw7h8",
            "validatorList": "FbGmG4xDpaTwLNtA7uBr4EBe4BUVeKK5LoYQyn2w1nBS",
            "voteAccount": "WENuuMXGi8adKogNbQj33Vxgia9oA2erkWAPF4szWN1"
        }
    },
    {
        "name": "camaoSOL",
        "symbol": "camaoSOL",
        "mint": "camaK1kryp4KJ2jS1HDiZuxmK7S6dyEtr9DA7NsuAAB",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/ifjpBZbaiieeDI7hIkVBpwNxaeaJxxYHzRpxJgsosf8",
        "pool": {
            "program": "SanctumSpl",
            "pool": "2RUTyfN8iq7Hsd2s9rLgrRT9VhHLuqkx2mGNgbuzbhTc",
            "validatorList": "E13TKF5Lecza7YS1sWZJiDS4EhiQdJjp8JguC374NAF7",
            "voteAccount": "76DafWkJ6pGK2hoD41HjrM4xTBhfKqrDYDazv13n5ir1"
        }
    },
    {
        "name": "dainSOL",
        "symbol": "dainSOL",
        "mint": "2LuXDpkn7ZWMqufwgUv7ZisggGkSE5FpeHCHBsRgLg3m",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/mIGq2RPhhypZ2yVI0QK5BMvpDRPxN3ei2_8KxA-dh3s",
        "pool": {
            "program": "SanctumSpl",
            "pool": "7qJ34Vq7nGZvk5YExkJsDZB6to6vz9RpcPmNEK84HjrV",
            "validatorList": "BUY9n8MMAX4rygB1scpQ2imB7gxLFyUWYKHDzZ9NibJs",
            "voteAccount": "AEtdq4CwtuktCEUWLLpRTNPBZs6tr7BBqxkHJ1DjAttR"
        }
    },
    {
        "name": "digitSOL",
        "symbol": "digitSOL",
        "mint": "D1gittVxgtszzY4fMwiTfM4Hp7uL5Tdi1S9LYaepAUUm",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/EU5JKGGQEQ3Rwj-LrFJdh7GhSBFoQ4TYvoDnmdZ0FcE",
        "pool": {
            "program": "SanctumSpl",
            "pool": "4qYufFsPQETukkXd5z9fxDsdwm8AEaSqzYpuzmZzCJxR",
            "validatorList": "842feRsGyLDY12fzcHDm5VrANqsC15koSHEtWiVxCCCf",
            "voteAccount": "Simpj3KyRQmpRkXuBvCQFS7DBBG6vqw93SkZb9UD1hp"
        }
    },
    {
        "name": "digitalSOL",
        "symbol": "digitalSOL",
        "mint": "3bfv2scCdbvumVBc3Sar5QhYXx7Ecsi8EFF2akjxe329",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://shdw-drive.genesysgo.net/3y9qiDjVtv8xcWsgad8zULmsqg8PLusetN55PdqtLhyr/tokenlogo.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "Fwy2jGmRCDjKpWTacMVvnLp66Fg4L5yhVCfahHsbjMGf",
            "validatorList": "2Visjfg7y5iMw9eiFjKipwG5dH1AsdFJu7sYpdwnWCcA",
            "voteAccount": "86Sw9R6ynPmXnHfwUWinXtq1QoF2KHesfQQyZG5r8sXo"
        }
    },
    {
        "name": "Delegate Liquid Staking SOL",
        "symbol": "dlgtSOL",
        "mint": "DLGToUUnqy9hXxpJTm5VaiBKqnw9Zt1qzvrpwKwUmuuZ",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/Sd_JW2vRM79deSN_BJgLbXN_LZjru4qbnO-uG_MEsHs",
        "pool": {
            "program": "SanctumSpl",
            "pool": "9pffpv2w65TSeZpD988hAjvvzUiF1KZN1Swx5j2zPCdy",
            "validatorList": "CNQhzVtQz9jZFLEpWYwZ3sKGM8s2tH1kj1BCzcZn442Q",
            "voteAccount": "AuBB9st3RqhHBkzZgBSm6SVnHZNJQSHeBWCSkik4bzdA"
        }
    },
    {
        "name": "Dual SOL",
        "symbol": "dualSOL",
        "mint": "DUAL6T9pATmQUFPYmrWq2BkkGdRxLtERySGScYmbHMER",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://www.dual.finance/images/token-logos/dualSOL.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "BmEgS5XpWJJDqT3FVfB6ZmoELQrWkJxDXo3cNoJVsNFK",
            "validatorList": "DJ2V46U5yjT2P2tJW6VMYeFFMgRmaKtDDNKEiMd3wDdB",
            "voteAccount": "CNcaYdqkCwxDpKSVK8in5f6kqrTiZ5SuHsHFDqx6jNvu"
        }
    },
    {
        "name": "Hanabi Staked SOL",
        "symbol": "haSOL",
        "mint": "haSo1Vz5aTsqEnz8nisfnEsipvbAAWpgzRDh2WhhMEh",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://shdw-drive.genesysgo.net/HjUWneFfxDo1WLdTSi8cngmyZMJHbGqt68iQ1LXJitES/firework_solana_512px.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "9ovWYMZp18Qn7UVbyUvwqLSBBSEPDDA5q9pUgDFy6R23",
            "validatorList": "9QhR8FfKqU6dpR83kvBrXE2U5uHJ4LXiAR9MgX1FNg5D",
            "voteAccount": "mintrNtxN3PhAB45Pt41XqyKghTTpqcoBkQTZqh96iR"
        }
    },
    {
        "name": "StakeHaus Staked SOL",
        "symbol": "hausSOL",
        "mint": "HausGKcq9G9zM3azwNmgZyzUvYeeqR8h8663PmZpxuDj",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://uqdeavtqqopuojyfesy44m54bi3lxfp4gqodt2zutdpdeboilnoa.arweave.net/pAZAVnCDn0cnBSSxzjO8Cja7lfw0HDnrNJjeMgXIW1w",
        "pool": {
            "program": "SanctumSpl",
            "pool": "5bzgfi7nidWWrp3DCwPwLzepw7PGgawRmMH9tqqXMZRj",
            "validatorList": "CVidorJPNKbhYvCKGBqF61PtAGJ5ipThYUBYZDFSDf1J",
            "voteAccount": "HxRrsnbc6K8CdEo3LCTrSUkFaDDxv9BdJsTDzBKnUVWH"
        }
    },
    {
        "name": "kumaSOL",
        "symbol": "kumaSOL",
        "mint": "KUMAgSzADhUmwXwNiUbNHYnMBnd89u4t9obZThJ4dqg",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/dBlyZZ8SRU8gbBLB_Ahil_NXCtsh67PI10mTq9qcMVA",
        "pool": {
            "program": "SanctumSpl",
            "pool": "Fvy5L7f3rduuYfRf9GR9fDqEgmJkYagDPh3Ddkp5jcoP",
            "validatorList": "AgSQoowD7n51jJu9QK6KV1X5f9wSVamq1T3LmUeMg5GH",
            "voteAccount": "4m1PbxzwLdUnEwog3T9UKxgjktgriHgE1CfAhMqDw7Xx"
        }
    },
    {
        "name": "Nordic Staked SOL",
        "symbol": "nordSOL",
        "mint": "nordEhq2BnR6weCyrdezNVk7TwC3Ej94znPZxdBnfLM",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/K151E1-jIi9nT5Vaf02ibUP7_XnO_GWuFi63-VYvwRI",
        "pool": {
            "program": "SanctumSpl",
            "pool": "GrrASJmjz19gHDsUUGv9y3gtRAwYJcdrtFESCRAosd44",
            "validatorList": "HfBndgMnK9otLp7ypMS3nf5qjWVbhNegd1zPVDm84okd",
            "voteAccount": "B1w6SZcyvjyp6zEyStcc8u9AxXAh2AbYvNzMmP9rRKE9"
        }
    },
    {
        "name": "polarSOL",
        "symbol": "polarSOL",
        "mint": "PoLaRbHgtHnmeSohWQN83LkwA4xnQt91VUqL5hx5VTc",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/UrbDD_0SPYXHAMD7-0pzErroi62ZHbub1VkBokrhvqM",
        "pool": {
            "program": "SanctumSpl",
            "pool": "EYwMHf8Ajnpvy3PqMMkq1MPkTyhCsBEesXFgnK9BZfmu",
            "validatorList": "EomwHLMfpzFLTxBzQbrf23e4TKhQgHgceHdFPDwaHhpo",
            "voteAccount": "CQr9DJLMeYqmXcfG8Z8cgSFw7ntXvVUamBM3dMVzWiJz"
        }
    },
    {
        "name": "StaRKe SOL",
        "symbol": "rkSOL",
        "mint": "EPCz5LK372vmvCkZH3HgSuGNKACJJwwxsofW6fypCPZL",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/INyKzzPVD4BUqqMgQbd_QxmhmPJq-NrLHujNTouwD4g",
        "pool": {
            "program": "SanctumSpl",
            "pool": "6LXCxeyQZqdAL4yLCtgATFYF6dcayWvsiwjtBFYVfb1N",
            "validatorList": "CYHKq8v8wPxWGTe6EM84Jpkiw54S3b9tpTA7Vh11LfNe",
            "voteAccount": "D3QPJm7BDzzPeRG51YZSEz3LfV7GvFNu9NkcibzURxuj"
        }
    },
    {
        "name": "reflectSOL",
        "symbol": "rSOL",
        "mint": "RSoLp7kddnNwvvvaz4b1isQy8vcqdSwXjgm1wXaMhD8",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/19iWtDeflweeEJCYPtuf7EpZ3oJs9mkxvxpejy3WHew",
        "pool": {
            "program": "SanctumSpl",
            "pool": "4gT1GaFtJK5pnX3CnjnSYwy8VUV9UdmozoQV9GCNk9RQ",
            "validatorList": "GgZb2DV3CkN6fu1oeJJL3gpfsUTn4yS7ptqWoJhn5VN1",
            "voteAccount": "rFLcT89WTT6kJsKmrMzpz5FUZHy7Z9bycBF1Q1SMy6i"
        }
    },
    {
        "name": "Hedgehog Spiky SOL",
        "symbol": "spikySOL",
        "mint": "spkyB5SzVaz2x3nNzSBuhpLSEF8otbRDbufc73fuLXg",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://storage.googleapis.com/hedgehog-images/BlueHeadLogo.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "GEGRQNw17Y5s44dRH69sk8bvhyj3i6VwgqGmN1MBHKHp",
            "validatorList": "34KzBwDeUGfgKrsYgcU3NvtGYqECXdPrQuKT4q7wUqiM",
            "voteAccount": "3dXXxEaV4fZqw1PL7VezfDkiJV5W4WTtRjh2EHgKSthF"
        }
    },
    {
        "name": "STAKR.space SOL",
        "symbol": "stakrSOL",
        "mint": "stkrHcjQGytQggswj3tCF77yriaJYYhrRxisRqe9AiZ",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/G47rsX4E-c8K52zGpqXgRtH9fQLoxkoAbNiT90HpN3k",
        "pool": {
            "program": "SanctumSpl",
            "pool": "9j2mFdABTCCnWnzLtpMjp86AEcm4e3XistVeuujds7Au",
            "validatorList": "CyHSFkjezzAEDgFWcFAp8ZjVP8m2ocDi9Gntw8Ko16T1",
            "voteAccount": "3a2onvgTpGynakAQwx6gigtSeL7itZewNxqb5JiAvWeA"
        }
    },
    {
        "name": "ElagabalX Staked SOL",
        "symbol": "xSOL",
        "mint": "B5GgNAZQDN8vPrQ15jPrXmJxVtManHLqHogj9B9i4zSs",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://shdw-drive.genesysgo.net/FfXMHMFwXLHkGZDVCgBzFFAP7eT7Jd23SzAXcUXsH8j4/xSOL.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "DYuSikgwzHidFo2b8jqrViW1psAb7hpawJnszBothRzp",
            "validatorList": "ABGjoe5jYWbmY3jMp9ZcWkryPQuJC6dDLMsSo5Z9UUEa",
            "voteAccount": "8gJCfKzr55gM6DtAaFqoWjBGAmsJ71mpHem6qJAASBU4"
        }
    },
    {
        "name": "Fuse Staked SOL",
        "symbol": "fuseSOL",
        "mint": "fuseYvhNJbSzdDByyTCrLcogsoNwAviB1WeewhbqgFc",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://fusesol.nyc3.digitaloceanspaces.com/fuseSOL.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "pjwKqvtt4ij6VJW4HxNxSaufSrkWHRc6iCTHoC4gFs4",
            "validatorList": "EQy3HcYA8MVzgQVTFWxdwP63GkmA77VCMeDH1S5KVLu3",
            "voteAccount": "SQDSVTDfE5HqL7D6RjZk1vvZhaheWoskrDdDHCki68w"
        }
    },
    {
        "name": "Mango SOL",
        "symbol": "mangoSOL",
        "mint": "MangmsBgFqJhW4cLUR9LxfVgMboY1xAoP8UUBiWwwuY",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://mango.markets/images/tokens/mangoSOL.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "9jWbABPXfc75wseAbLEkBCb1NRaX9EbJZJTDQnbtpzc1",
            "validatorList": "BaWQieBbZvkwB4qfiPUaWZP9pWgGNPeTM6VsfWRLw7CQ",
            "voteAccount": "5EYp3kCdMLq52vzZ4ucsVyYaaxQe5MKTquxahjXpcShS"
        }
    },
    {
        "name": "apySOL",
        "symbol": "apySOL",
        "mint": "apySoLhdVa6QbvNyEjXCbET3FdUm9cCdEvYyjCU7icM",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://apysol.io/img.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "FxhzbU8rn4MhZxmeH2u7M18qkvFH3LjkWk8z9686TE45",
            "validatorList": "4zDzb3SKgCuHoT9qnUy1M7xT5vQyRuVzEwA5egmaqc8F",
            "voteAccount": "apySoLRzPkGf8EEinWQjAbL6B4frjgx4gG4YePoM9NJ"
        }
    },
    {
        "name": "Step Staked SOL",
        "symbol": "stepSOL",
        "mint": "StPsoHokZryePePFV8N7iXvfEmgUoJ87rivABX7gaW6",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://step-public.s3.eu-north-1.amazonaws.com/StepSOL.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "7yQNEvbzH6KffCY7iYFrKCKXv8c9zB9jJREmPK6gBVYz",
            "validatorList": "HtCNz5bc521vH3DEjHv8W1Zbc2QZBev9quyMBurk9YzK",
            "voteAccount": "StepeLdhJ2znRjHcZdjwMWsC4nTRURNKQY8Nca82LJp"
        }
    },
    {
        "name": "Urban Staked SOL",
        "symbol": "uSOL",
        "mint": "uSo1ynGWS3qc2B1nN2MmEHN5cYaNbT7vJp87LtgkpV8",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/hrYI439t97ffLMJTWzAGc2qJApoAunr-Dw0Q86IxNbE",
        "pool": {
            "program": "SanctumSpl",
            "pool": "9h8whamW6ydU5EunuPqY7yWP2VFDjsCtorGjtWvNnJ54",
            "validatorList": "EQ9n3ccwrvNtkm4FWmu8MeMZMJQfye48A9hDKEHx6wWh",
            "voteAccount": "ET5johBaPyWugD2Mx1zbTCvvbedxZFURembUHng1rzfZ"
        }
    },
    {
        "name": "lotusSOL",
        "symbol": "lotusSOL",
        "mint": "gangqfNY8fA7eQY3tHyjrevxHCLnhKRrLGRwUMBR4y6",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://arweave.net/G9bkE8AlT7NBw0E6sBKtPziO6toOhI5Y6jIzU27klec",
        "pool": {
            "program": "SanctumSpl",
            "pool": "4yQWc4Zss8YqWoVCwuSm3wVXebdHx9z6dPigH5eLqugm",
            "validatorList": "8CqAg6YKCArk7WKe1Xn7GHb8n6kfRvbuiG93rPh33FRY",
            "voteAccount": "gangtRyGPTvYWb8K3xS2feJQaCks4iJ7rytFUPtVqSY"
        }
    },
    {
        "name": "eonSOL",
        "symbol": "eonSOL",
        "mint": "eon5tgYNk5FjJUcBUcLno49t2GfpmWZDzJHeYkbh9Zo",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://shdw-drive.genesysgo.net/Ctn1Td5TTdb6FumGxUCc8ZGiiMHQujKQYPwnV2DjaBtv/eonSOL.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "G9Jgnqhq5MaDNmLSgTDSmiWRcmq67Q7yVnXjoA8tUsGX",
            "validatorList": "GL5ufRF8vAtrWQmdnny2qhXG5RtBrQtyzKdpY5w3qZxg",
            "voteAccount": "eondcw2upjH14EuvBzmn6HfGEGo8t9hG9JbXtPj6cym"
        }
    },
    {
        "name": "Guardian Staked SOL",
        "symbol": "gS",
        "mint": "gSvP9zBJ33pX7W2finzAYJZp6Q9ipNAQ19xU9PrCirz",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/Guardian-Validator/gS/main/gS.svg",
        "pool": {
            "program": "SanctumSpl",
            "pool": "6KrUyxQR9ia4WCozrRzwkqpFrh9jzsmzrrEypfnz6bqh",
            "validatorList": "oEiWyLLiafFksCtcRfDcTfgkFa5sEPxrYMGtFHgSWRF",
            "voteAccount": "GE6atKoWiQ2pt3zL7N13pjNHjdLVys8LinG8qeJLcAiL"
        }
    },
    {
        "name": "BybitSOL",
        "symbol": "bbSOL",
        "mint": "Bybit2vBJGhPF52GBdNaQfUJ6ZpThSgHBobjWZpLPb4B",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://static.bymj.io/web3/staking/bbsol/bbsol2.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "2aMLkB5p5gVvCwKkdSo5eZAL1WwhZbxezQr1wxiynRhq",
            "validatorList": "BPVx5RBixdZVecvoDSFECMc8jXkLNTmQp65WYKJz9nr5",
            "voteAccount": "8hPk5CbKDoM7dN9LssTdVkFhDykeq7A8CZurA5AQSFJH"
        }
    },
    {
        "name": "Rug City SOL",
        "symbol": "rugSOL",
        "mint": "rug3uop5ibttn6FoQe5WLiZ1cW6wTUymnSECB6GXvta",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://www.rugcity.xyz/ruglogo.png",
        "pool": {
            "program": "SanctumSpl",
            "pool": "GcmRJv4YShwhGpSfgCpq9Vp6hjrv9SZD59nnP8UtuKDe",
            "validatorList": "7JyHZk4Mdmv1wndBEZZJ2L4og5Pn92privxBo9DJWakb",
            "voteAccount": "6MP6Bun9VmkGcRVU4iF14Q8P7jTkGtQW9zVwmB9kCYyK"
        }
    },
    {
        "name": "SOL",
        "symbol": "SOL",
        "mint": "So11111111111111111111111111111111111111112",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/So11111111111111111111111111111111111111112/logo.png",
        "pool": {
            "program": "ReservePool"
        }
    },
    {
        "name": "Infinity",
        "symbol": "INF",
        "mint": "5oVNBeEEQvYi1cX3ir8Dx5n1P7pdxydbGF2X4TxVusJm",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://bafkreiflz2xxkfn33qjch2wj55bvbn33q3s4mmb6bye5pt3mpgy4t2wg4e.ipfs.nftstorage.link/",
        "pool": {
            "program": "SPool",
            "programId": "5ocnV1qiCgaQR8Jb8xWnVbApfaygJ8tNoZfgPwsgx9kx"
        }
    },
    {
        "name": "Lido Staked SOL",
        "symbol": "stSOL",
        "mint": "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj/logo.png",
        "pool": {
            "program": "Lido"
        }
    },
    {
        "name": "Marinade staked SOL",
        "symbol": "mSOL",
        "mint": "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
        "decimals": 9,
        "tokenProgram": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
        "logoUri": "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So/logo.png",
        "pool": {
            "program": "Marinade"
        }
    }
];
